import React, { Component } from "react";
import styled from "styled-components";
import { Redirect } from 'react-router-dom';

// Utils //
import history from "utils/history";

// HOC //
import withChat from "hoc/withChat";

// Components //
import View from 'components/View';
import CodeEditor from "components/CodeEditor";
import Text from "components/Text";
import StepHeader from 'components/StepHeader';
import StepFooter from 'components/StepFooter';
import Callout from 'components/Callout';
import SuccessMessage from 'components/SuccessMessage';
import ErrorMessage from 'components/ErrorMessage';

const Root = styled(View)``;

const TextWrapper = styled(View)`
  margin-top: 24px;
  margin-bottom: 40px;
`;

const defaultValue = `const message = await channel.sendMessage({
  text: "Did you already see the trailer? https://www.youtube.com/watch?v=wA38GCX4Tb0",
});

return message;`;

class Step3 extends Component {
  state = {
    hasRan: false,
    value: defaultValue
  };

  hasRan = async () => {
    const { channel, error, match, setError, setLoading, setMessageId, setStepComplete } = this.props; // eslint-disable-line no-unused-vars
    const { value } = this.state;

    try {
      await setLoading(true);
      const { message } = await eval(`(async () => {${value}})();`); // eslint-disable-line no-eval
      setMessageId(message.id);
      await setStepComplete(2);
      await setLoading(false);

      this.setState({ hasRan: true });
    } catch (err) {
      await setLoading(false);
      setError(err.message);
    }
  };

  handleCodeChange = value => {
    this.setState({
      value
    });
  };

  handlePrevClick = () => history.push(`/step-2`);

  handleNextClick = () => history.push(`/step-4`);

  render() {
    const { client, channel, completedSteps, error, loading } = this.props;
    const { hasRan, value } = this.state;
    const isComplete = completedSteps.includes(2);

    if (!client || !channel) {
      return <Redirect to="/step-1" />
    }

    return (
      <Root>
        <StepHeader
          step={3}
          title="Send Message & Attachment"
        >
          <Text size={18}>
            Now that we have a channel up and runnning you can add a message to the channel like this:
          </Text>
        </StepHeader>
        <TextWrapper>
          <Text>
            Messages are displayed in real-time within the UI on the right. Run the code below to see a message with a rich video preview. Similar to users and channels, messages also allow you to attach custom data if needed.
          </Text>
        </TextWrapper>
        <CodeEditor
          onChange={this.handleCodeChange}
          onRunClick={this.hasRan}
          value={value}
          runLabel="Send Message"
        />
        <Callout style={{marginTop: 24}}>
          <Text
            size={15}
          >
            <b>NOTE:</b> The display on the right is using our standard <a target="_blank" rel="noopener noreferrer" href="https://getstream.github.io/stream-chat-react/">React Chat components</a>. You don’t need to use these components, but they provide a convenient and flexible starting point.
          </Text>
        </Callout>
        {hasRan && (
          <SuccessMessage
            style={{marginTop: 16}}
            text="Mesage Sent"
          />
        )}
        {hasRan && (
          <>
            <Text style={{ marginTop: 14 }}>
              <em>
                <strong>Note</strong>: The message is displayed in real-time
                within the UI on the right. The provided URL is shown with a rich
                video preview. Similar to users and channels, messages also allow
                you to attach custom data if needed.
              </em>
            </Text>
          </>
        )}
        <StepFooter
          disableNext={!isComplete && !hasRan}
          loading={loading}
          onNextClick={this.handleNextClick}
          onPrevClick={this.handlePrevClick}
        />
        {error && <ErrorMessage
          error={error}
        />}
      </Root>
    );
  }
}

export default withChat(Step3);
